import React from 'react'

import { IS_PRODUCTION } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'

import { DevToolsModal } from './DevToolsModal'
import { useDevTools } from './DevToolsProvider'

export const DevToolsModalWrapper: React.FC = () => {
  const { isDevToolsOpen } = useDevTools()

  if (IS_PRODUCTION || !isDevToolsOpen) {
    return null
  }

  return <DevToolsModal />
}
